import axios from "axios";

const debug = process.env.NODE_ENV !== "production";

const baseURL = debug 
  ? "http://localhost:8080"
  : "https://taochin.xyz/";

// const baseURL = "https://taochin.xyz/";

let api = axios.create({baseURL});
export default api;